<!--<template>-->
<!--  <div>-->
<!--    <h2 class="text-lg font-semibold mb-4">Archived Messages</h2>-->

<!--    <div v-if="messages.length > 0" class="overflow-x-auto">-->
<!--      <table class="min-w-full bg-white rounded-lg shadow-md">-->
<!--        <tbody>-->
<!--        <tr-->
<!--            v-for="message in messages"-->
<!--            :key="message.id"-->
<!--            class="border-t hover:bg-gray-50 transition"-->
<!--        >-->
<!--          <td class="px-6 py-4">-->
<!--            <p class="text-gray-400">{{ message.sender }}</p>-->
<!--            <div>-->
<!--              <strong class="ml-1">{{ message.subject }}</strong>-->
<!--            </div>-->
<!--          </td>-->

<!--          <td class="px-6 py-4 text-sm text-gray-500">-->
<!--            {{ formatDate(message.created_at) }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->

<!--    <p v-else class="text-gray-500">No archived messages.</p>-->
<!--  </div>-->

<!--  <transition name="modal-overlay">-->
<!--    <div-->
<!--        v-if="selectedTicket"-->
<!--        class="fixed inset-0 h-full bg-black/50 flex justify-center items-center z-50"-->
<!--    >-->
<!--      <div class="bg-white dark:bg-gray-900 dark:text-white rounded-lg w-11/12 md:w-3/4 max-w-2xl p-6 relative flex flex-col max-h-[80vh]">-->
<!--        &lt;!&ndash; Close button &ndash;&gt;-->
<!--        <button-->
<!--            @click="selectedTicket = null"-->
<!--            class="absolute top-2 right-2 text-gray-700 dark:text-gray-300 text-2xl leading-none"-->
<!--        >&times;</button>-->

<!--        <h2 class="text-xl font-bold mb-4">{{ selectedTicket.subject ?? 'No subject' }}</h2>-->

<!--        &lt;!&ndash; Messages container &ndash;&gt;-->
<!--        <div ref="messagesContainer" class="overflow-y-auto mb-4 space-y-2 flex-1">-->
<!--          <div-->
<!--              v-for="(msg, index) in ticketMessages"-->
<!--              :key="index"-->
<!--              class="p-2 rounded border dark:border-gray-700 bg-gray-50 dark:bg-gray-800"-->
<!--          >-->
<!--            <div class="flex items-baseline justify-between">-->
<!--              <div>-->
<!--                <span class="font-semibold mr-2">{{ msg.from }}:</span>-->
<!--                <span>{{ msg.text }}</span>-->
<!--              </div>-->
<!--              <div class="text-xs text-gray-500 ml-4 whitespace-nowrap">{{ formatRelative(msg.date) }}</div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div v-if="ticketMessages.length === 0" class="text-sm text-gray-500">-->
<!--            No messages yet.-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; Reply + Archive &ndash;&gt;-->
<!--        <div class="flex flex-col gap-2">-->
<!--            <textarea-->
<!--                v-model="replyText"-->
<!--                class="w-full p-2 border rounded dark:bg-gray-800 dark:text-white"-->
<!--                placeholder="Write a reply..."-->
<!--                rows="4"-->
<!--            ></textarea>-->

<!--          <div class="flex gap-2 justify-between">-->
<!--            <button-->
<!--                @click="archiveTicket"-->
<!--                class="px-3 py-2 border rounded bg-red-500 text-white hover:bg-red-600 text-sm"-->
<!--            >-->
<!--              Archive-->
<!--            </button>-->

<!--            <div class="flex gap-2">-->
<!--              <button-->
<!--                  @click="selectedTicket = null"-->
<!--                  class="px-3 py-2 border rounded bg-transparent text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-white/[0.03]"-->
<!--              >-->
<!--                Cancel-->
<!--              </button>-->

<!--              <button-->
<!--                  @click="sendReply"-->
<!--                  :disabled="!canSend"-->
<!--                  class="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm"-->
<!--              >-->
<!--                Send Reply-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </transition>-->
<!--</template>-->

<!--<script setup>-->
<!--import { ref, onMounted } from "vue"-->
<!--import api from "@/services/api";-->

<!--const messages = ref([])-->

<!--const fetchArchived = async () => {-->
<!--  const res = await api.get("/messages/archived", {-->
<!--    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },-->
<!--  })-->
<!--  console.log("dcddc",res);-->
<!--  messages.value = res.data-->
<!--}-->

<!--function formatDate(dateString) {-->
<!--  const options = { year: "numeric", month: "short", day: "numeric" }-->
<!--  return new Date(dateString).toLocaleDateString(undefined, options)-->
<!--}-->

<!--onMounted(fetchArchived)-->
<!--</script>-->


<template>
  <div>
    <h2 class="text-lg font-semibold mb-4">Archived Messages</h2>

    <div v-if="messages.length > 0" class="overflow-x-auto">
      <table class="min-w-full bg-white rounded-lg shadow-md">
        <tbody>
        <tr
            v-for="message in messages"
            :key="message.id"
            class="border-t hover:bg-gray-50 transition cursor-pointer"
            @click="openTicket(message.id)"
        >
          <td class="px-6 py-4">
            <p class="text-gray-400">{{ message.sender }}</p>
            <div>
              <strong class="ml-1">{{ message.subject }}</strong>
            </div>
          </td>

          <td class="px-6 py-4 text-sm text-gray-500">
            {{ formatDate(message.created_at) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-gray-500">No archived messages.</p>

    <!-- Modal -->
    <transition name="modal-overlay">
      <div
          v-if="selectedTicket"
          class="fixed inset-0 h-full bg-black/50 flex justify-center items-center z-50"
      >
        <div class="bg-white dark:bg-gray-900 dark:text-white rounded-lg w-11/12 md:w-3/4 max-w-2xl p-6 relative flex flex-col max-h-[80vh]">
          <!-- Close button -->
          <button
              @click="selectedTicket = null"
              class="absolute top-2 right-2 text-gray-700 dark:text-gray-300 text-2xl leading-none"
          >&times;</button>

          <h2 class="text-xl font-bold mb-4">{{ selectedTicket.subject ?? 'No subject' }}</h2>

          <!-- Messages container -->
          <div ref="messagesContainer" class="overflow-y-auto mb-4 space-y-2 flex-1">
            <div
                v-for="(msg, index) in ticketMessages"
                :key="index"
                class="p-2 rounded border dark:border-gray-700 bg-gray-50 dark:bg-gray-800"
            >
              <div class="flex items-baseline justify-between">
                <div>
                  <span class="font-semibold mr-2">{{ msg.from }}:</span>
                  <span>{{ msg.text }}</span>
                </div>
                <div class="text-xs text-gray-500 ml-4 whitespace-nowrap">{{ formatRelative(msg.date) }}</div>
              </div>
            </div>

            <div v-if="ticketMessages.length === 0" class="text-sm text-gray-500">
              No messages yet.
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watch } from "vue";
import api from "@/services/api";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const messages = ref([]);
const selectedTicket = ref(null);
const messagesContainer = ref(null);

// Fetch archived messages
const fetchArchived = async () => {
  const res = await api.get("/messages/archived", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  messages.value = res.data;
};

onMounted(fetchArchived);

// Open a message in modal
const openTicket = async (id) => {
  try {
    const res = await api.get(`/messages/archived/details/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    selectedTicket.value = res.data;
  } catch (err) {
    console.error(err);
    alert("Failed to load message");
  }
};

// Ticket messages
const ticketMessages = computed(() => {
  if (!selectedTicket.value) return [];
  let msgs = [];
  if (selectedTicket.value.body) {
    msgs.push({
      from: selectedTicket.value.sender || 'You',
      text: selectedTicket.value.body,
      date: selectedTicket.value.created_at
    });
  }
  if (selectedTicket.value.replies?.length) {
    selectedTicket.value.replies.forEach(r => {
      msgs.push({
        from: r.admin?.name || 'Admin',
        text: r.reply,
        date: r.created_at
      });
    });
  }
  return msgs.sort((a, b) => new Date(a.date) - new Date(b.date));
});

// Scroll to bottom when modal opens
watch(ticketMessages, async () => {
  await nextTick();
  if (messagesContainer.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
  }
});

function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

const formatRelative = (date) => dayjs(date).fromNow();
</script>
